/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import * as size from '@constant/size';
import * as color from '@constant/color';
import * as text from '@constant/text';
import * as design from '@constant/design';
import TextBlock from 'component/common/block/text-block';
import AuthBox from 'component/auth/auth-box';
import Gap from '@component/common/gap';
import ImageTextBlock from '@component/common/block/image-text-block';
import Scroll from '@component/common/scroll';
import { useNavigate, useLocation } from 'react-router-dom';
import { createAuthLogoText } from '@util/string';
import { createAuthLogoImage } from '@util/image';
import { AUTH_PATH } from '@constant/auth/route-path';
import { getInitialServicePath } from '@constant/common/route-path';

interface IProps {
  mode: 'term' | 'service-term' | 'private-term' | 'account-term';
}

const TERM_SCROLL_HEIGHT = '300px'; //'100px';

const TERM_LABEL_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BLACK_1 },
  box: { width: '100%', alignX: 'left' },
} as const;

const TERM_VIEW_TEXT_DESIGN = {
  text: { size: 'tiny', color: color.GRAY_1 },
  box: { width: '100%', alignX: 'left' },
} as const;

const TermDescription = styled.div`
  white-space: pre-wrap;
  padding: ${size.MARGIN_1};
  border-radius: ${size.BORDER_RADIUS_2};
  background-color: ${color.GRAY_4};
`;

const TermPage: React.FC<IProps> = ({ mode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const closePath = (location.state as { closePath?: string })?.closePath;
  const handleCloseClick = () => navigate(closePath ?? getInitialServicePath(), { replace: true });

  return (
    <AuthBox design={design.AUTH_BOX_DESIGN} onCloseClick={handleCloseClick}>
      <ImageTextBlock
        src={createAuthLogoImage()}
        alt='otterbrick'
        text={createAuthLogoText()}
        design={design.AUTH_LOGO_DESIGN}
      />
      <Gap height={size.MARGIN_2} />
      {mode === 'service-term' && (
        <>
          <TextBlock text={'서비스이용'} design={TERM_LABEL_TEXT_DESIGN} />
          <Gap height={'5px'} />
          <TermDescription>
            <Scroll direction='y' height={TERM_SCROLL_HEIGHT}>
              <TextBlock text={text.SERVICE_TERM} design={TERM_VIEW_TEXT_DESIGN} />
            </Scroll>
          </TermDescription>
        </>
      )}
      {/*<Gap height={size.MARGIN_4} />*/}
      {mode === 'private-term' && (
        <>
          <TextBlock text={'개인정보처리 방침'} design={TERM_LABEL_TEXT_DESIGN} />
          <Gap height={'5px'} />
          <TermDescription>
            <Scroll direction='y' height={TERM_SCROLL_HEIGHT}>
              <TextBlock text={text.INFORMATION_TERM} design={TERM_VIEW_TEXT_DESIGN} />
            </Scroll>
          </TermDescription>
        </>
      )}
      {mode === 'account-term' && (
        <>
          <TextBlock text={'계정관리 방침'} design={TERM_LABEL_TEXT_DESIGN} />
          <Gap height={'5px'} />
          <TermDescription>
            <Scroll direction='y' height={TERM_SCROLL_HEIGHT}>
              <TextBlock text={text.ACCOUNT_TERM} design={TERM_VIEW_TEXT_DESIGN} />
            </Scroll>
          </TermDescription>
        </>
      )}
    </AuthBox>
  );
};

export default TermPage;
